export default "__VITE_ASSET__kLLSlQ5p__"